import styled from 'styled-components'
import Spline from '@splinetool/react-spline';

export const Spline1 = styled(Spline)`
    @media screen and (max-width:992px){
        display: none;
    }
`
export const Robot = styled.div`
    width:600px;
    height: 70vh;
    @media screen and (max-width:992px){
        display: none;
    }
`
export const Image = styled.img`
    background-color: white;
    width: 200px;
    border-radius: 50%;
    padding: 20px;
    align-self: center;
    @media screen and (min-width:990px){
        display: none;
    }
`
export const Heading = styled.h1`
    color: ${props => props.theme === 'light' ? '#000000' : '#FFFFFF'};
    font-family: "Lobster Two", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 48px;
`
export const Homepage = styled.div`
    background-image: ${props => props.theme === 'light' ? 'linear-gradient(100deg,#b4a0d9,#5123a6)' : 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),linear-gradient(100deg, #3e2f5c, #1f0e3a)'};
    ${'' /* background-image:url('https://template.canva.com/EAGMgsrvfZw/1/0/1600w-YC2GhPtpbtM.jpg'); */}
    background-size: cover;
    padding: 0px 100px;
    @media screen and (max-width: 768px){
        padding: 0px 20px;
    }
`;
export const MainContainer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: center;
    height: 90vh;
    @media screen and (min-width:768px){
        flex-direction:row;
        justify-content:space-around;
        align-items: center;
    }
`
export const HomeContainer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    order:2;
    margin:20px;
    @media screen and (min-width:768px){
        order:0;
        min-height:70vh;
    }
`;
export const Profession = styled.h1`
    color:#fff37a;
`;
export const Description = styled.p`
    color: ${props => props.theme === 'light' ? '#000000' : '#FFFFFF'};
    max-width: 350px;
`;
export const LinkButton = styled.a`
    background-color: transparent;
    border:solid 1px ${props => props.theme === 'light' ? '#5423a8' : '#FFFFFF'};
    color: ${props => props.theme === 'light' ? '#5423a8' : '#FFFFFF'};
    border-radius: 40px;
    padding: 0px 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    text-decoration: none;
`;
export const ResumeButton = styled.a`
    background-color: transparent;
    border:solid 1px ${props => props.theme === 'light' ? '#5423a8' : '#FFFFFF'};
    color: ${props => props.theme === 'light' ? '#5423a8' : '#FFFFFF'};
    border-radius: 20px;
    padding: 5px 15px;
    font-weight: bold;
    font-size: 12px;
    margin-right: 10px;
    text-decoration: none;
`;
export const Achievements = styled.div`
    display:flex;
    justify-content: space-around;
    flex-wrap:wrap;
`
export const Box = styled.div`
    
`
export const Dot = styled.span`
    height: 15px;
    width: 15px;
    border-radius: 50px;
    background-color: #ffffff;
    position: absolute;
    top: 20%;
    left: 20%;
`
export const SubBox = styled.div`
    height: 60px;
    width: 60px;
    border: solid 2px #ffffff;
    border-radius: 50px;
    position: absolute;
    top: 10%;
    left: 10%;
    animation: 4s linear infinite;
    &:nth-child(1){
        top: 12%;
        left: 12%;
        animation: animate 10s linear infinite;
    }
    &:nth-child(2){
        top: 70%;
        left: 50%;
        animation: animate 7s linear infinite;
    }
    &:nth-child(3){
        top: 17%;
        left: 6%;
        animation: animate 9s linear infinite;
    }
    &:nth-child(4){
        top: 20%;
        left: 60%;
        animation: animate 10s linear infinite;
    }
    &:nth-child(5){
        top: 67%;
        left: 10%;
        animation: animate 6s linear infinite;
    }
    &:nth-child(6){
        top: 67%;
        left: 70%;
        animation: animate 12s linear infinite;
    }
    &:nth-child(7){
        top: 60%;
        left: 80%;
        animation: animate 15s linear infinite;
    }
    &:nth-child(8){
        top: 32%;
        left: 25%;
        animation: animate 16s linear infinite;
    }
    &:nth-child(9){
        top: 90%;
        left: 25%;
        animation: animate 9s linear infinite;
    }
    &:nth-child(10){
        top: 20%;
        left: 80%;
        animation: animate 5s linear infinite;
    }
    @media screen and (max-width:768px){
        &:nth-child(1){
        top: 10%;
        left: 12%;
        animation: animate 10s linear infinite;
    }
    &:nth-child(2){
        top: 30%;
        left: 70%;
        animation: animate 7s linear infinite;
    }
    &:nth-child(3){
        top: 20%;
        left: 6%;
        animation: animate 9s linear infinite;
    }
    &:nth-child(4){
        top: 40%;
        left: 75%;
        animation: animate 10s linear infinite;
    }
    &:nth-child(5){
        top: 50%;
        left: 10%;
        animation: animate 6s linear infinite;
    }
    &:nth-child(6){
        top: 20%;
        left: 60%;
        animation: animate 12s linear infinite;
    }
    &:nth-child(7){
        top: 25%;
        left: 80%;
        animation: animate 15s linear infinite;
    }
    &:nth-child(8){
        top: 30%;
        left: 15%;
        animation: animate 16s linear infinite;
    }
    &:nth-child(9){
        top: 40%;
        left: 20%;
        animation: animate 9s linear infinite;
    }
    &:nth-child(10){
        top: 50%;
        left: 80%;
        animation: animate 5s linear infinite;
    } 
    }
    @keyframes animate{
        0%{
            transform: scale(0) translateY(0) rotate(0);
        }
        100%{
            transform: scale(1.3) translateY(-100px) rotate(360deg);
            opacity: 0;
        }
    }
`
